import React from "react";

function InterviewDetails({ appDetails, clickView }) {
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Application Details
      </h6>
      <p className="mb-1">
        <strong>Name:</strong> {appDetails?.firstName} {appDetails?.middleName}{" "}
        {appDetails?.lastName}
      </p>
      <p className="mb-1">
        <strong>Position:</strong> {appDetails?.positionApplied}
      </p>
      <p className="mb-1">
        <strong>Birthdate:</strong>{" "}
        {new Date(appDetails?.birthDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>
      <p className="mb-1">
        <strong>Age:</strong> {appDetails?.age}
      </p>
      <p className="mb-1">
        <strong>Telephone No.:</strong> {appDetails?.present_telephone}
      </p>
      {/* Buttons */}
      <div className="mt-3">
        <button
          className="btn text-white w-100"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickView()}
        >
          View Application
        </button>
      </div>
    </div>
  );
}

export default InterviewDetails;
